export default __webpack_public_path__ + "static/media/S.8074b19e.png";